import { useState, useEffect } from 'react';

import { Input, Select, Button, useDisclosure, useToast } from '@chakra-ui/react';
import { HttpStatusCode } from 'axios';
import { useNavigate } from 'react-router-dom';

import AddIcon from '@/assets/AddIcon';
import { ALLOWED_CHARACTERS_REGEX, DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, DURATION_TOAST, INVOICE_STATUS, PAYMENT_STATUS, ROLES, SIRE_REVIEW_INVOICE_TYPE, COLORS } from '@/common/constants';
import ModalDelete from '@/components/Modals/ModalDelete';
// import ModalBulkPaymentConfirmation from '@/components/Modals/ModalBulkPaymentConfirmation';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { RootState } from '@/redux/store';
import { setDataTotalNewInvoiceInspectingCompany, setDataTotalNewInvoiceShipOperator } from '@/redux/slices/notificationSlice';
import { downloadFile, downloadFileZip, /*downloadFileZip*/ } from '@/services/downloadService';
import { getNewRecordCounterAdminFinance, getNewRecordCounterSuperAdmin } from '@/services/newRecordCounterService';
import { deleteSireReviewRequestorInvoice, getListSireReviewRequestorInvoices, getListSireReviewRequestorInvoicesByRequestor, getListSireReviewRequestorInvoicesFinance, postUpdateSireReviewRequestorInvoicePayment, SireReviewRequestorInvoice } from '@/services/InvoiceSireReviewRequestorService';
import TableInvoiceSireReviewRequestor from '@/components/Tables/TableInvoiceSireReviewRequestor';
import ModalSireRequestorPaymentConfirm from '@/components/Modals/ModalSireRequestorPaymentConfirm';

import '../../styles/ListPage.css';

const InvoicesSireReviewRequestorList = () => {
    const navigate = useNavigate();
    const { isOpen, onOpen, onClose } = useDisclosure();
    //const { isOpen: isOpenView, onOpen: onOpenView, onClose: onCloseView } = useDisclosure();
    // const { isOpen: isOpenBulk, onClose: onCloseBulk } = useDisclosure();
    const { isOpen: isOpenConfirmation, onOpen: onOpenConfirmation, onClose: onCloseConfirmation } = useDisclosure();
    const role = useAppSelector((state: RootState) => state.account.roleName);
    // const dataRaw = useAppSelector((state: RootState) => state.payment.multiplePayment);
    const name = useAppSelector((state: RootState) => state.account.name);
    const companyId = useAppSelector((state: RootState) => state?.account?.appId);
    const toast = useToast();
    const dispatch = useAppDispatch();

    const [approvalNote, setApprovalNote] = useState('');
    const [approvalStatus, setApprovalStatus] = useState('-1');
    // const [bulkPaymentDate, setBulkPaymentDate] = useState(null) as any;
    const [currentPageNumber, setCurrentPageNumber] = useState(DEFAULT_PAGE_NUMBER);
    const [currentPageSize, setCurrentPageSize] = useState(DEFAULT_PAGE_SIZE);
    const [dataList, setDataList] = useState<SireReviewRequestorInvoice[]>([]);
    const [errorMessageApproval, setErrorMessageApproval] = useState('');
    const [errorMessageNote, setErrorMessageNote] = useState('');
    const [hasNextPage, setHasNextPage] = useState(false);
    const [idDelete, setIdDelete] = useState('');
    //const [idViewConfirmation, setIdViewConfirmation] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    //const [, setIsValidToPay] = useState(false);
    const [invoiceStatus, setInvoiceStatus] = useState('');
    const [paymentStatus, setPaymentStatus] = useState('');
    const [searchValue, setSearchValue] = useState('');
    //const [selectedDataView, setSelectedDataView] = useState<any>(null);
    const [totalPageNumber, setTotalPageNumber] = useState(1);
    // const [uploadedFile, setUploadedFile] = useState(null) as any;
    //const [selectedSequenceId, setSelectedSequenceId] = useState('');
    const [dataConfirmation, setDataConfirmation] = useState<any>(null);
    const [idConfirmationPayment, setIdConfirmationPayment] = useState('');
    const [totalAmountIDR, setTotalAmountIDR] = useState<number>(0);

    const handleNavAdd = () => {
        navigate('/manage-invoices/sire-requestor/add');
    }

    const handleChangeSearch = (value: string) => {
        setSearchValue(value);
    }

    const handleSubmitSearch = () => {
        getData();
    }

    const handleEdit = (idEdit: string) => {
        navigate('/manage-invoices/sire-requestor/edit', { state: { id: idEdit } });
    }

    const handleDelete = (id: string) => {
        setIdDelete(id);
        onOpen();
    }

    const handleConfirmDelete = async () => {
        const response = await deleteSireReviewRequestorInvoice(idDelete, (name || "System"));
        if (response.status === HttpStatusCode.Ok) {
            getData();
            toast({
                title: 'Invoice deleted.',
                description: "We've deleted invoice for you.",
                status: 'success',
                duration: DURATION_TOAST,
                isClosable: true,
            });
        } else {
            toast({
                title: 'Invoice failed to delete.',
                description: "We failed to delete invoice for you.",
                status: 'error',
                duration: DURATION_TOAST,
                isClosable: true,
            });
        }

        onClose();
    }

    /*const handleView = (idView: string, sequenceID: string) => {
        setSelectedSequenceId(sequenceID);
        setErrorMessageNote('');
        setIdViewConfirmation(idView);
        const data = dataList.find((x: any) => x.id === idView);
        if (data) {
            setSelectedDataView(data);
        }

        onOpenView();
    }*/

    const handleConfirmToCancelConfirmation = () => {
        setApprovalStatus('');
			setApprovalNote("")
        onCloseConfirmation();
    }

    /*const handleConfirmView = async () => {
        if (approvalStatus === '3' && approvalNote.trim() === '') {
            setErrorMessageNote('Note is required');
            return;
        }

        if (errorMessageNote) {
            return;
        }

        const obj = {
            invoiceId: idViewConfirmation,
            sequenceID: selectedSequenceId,
            invoiceStatus: Number(approvalStatus),
            note: approvalNote,
            modifiedBy: name || "System"
        }

        const response = await updateInvoiceStatusInspector(obj) as any;
        if (response.status === HttpStatusCode.Ok) {
            getData();
            toast({
                title: 'Invoice status updated.',
                description: "We've updated invoice status for you.",
                status: 'success',
                duration: DURATION_TOAST,
                isClosable: true,
            });
        } else {
            toast({
                title: 'Invoice failed to update.',
                description: "We failed to update invoice status for you.",
                status: 'error',
                duration: DURATION_TOAST,
                isClosable: true,
            });
        }

        onCloseView();
    }*/

    const handlePay = (idPay: string) => {
        navigate('/manage-invoices/sire-requestor/payment', { state: { id: idPay, type: SIRE_REVIEW_INVOICE_TYPE.REQUESTOR } });
    }

    const handleChangeApprovalStatus = (value: string) => {
        if (value !== '-1'){
            setErrorMessageApproval('');
        }
        setApprovalStatus(value);
    }

    const handleChangeNote = (value: string) => {
        setErrorMessageNote('');

        if (value) {
            if (value.length > 50) {
                setErrorMessageNote('Max length is 50 characters');
            }

            const result = ALLOWED_CHARACTERS_REGEX.test(value);
            if (result) {
                setErrorMessageNote('');
            } else {
                setErrorMessageNote('Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.');
            }
        } else {
            setErrorMessageNote('Note is required');
        }

        setApprovalNote(value);
    }

    // const handleMultiplePayment = () => {
    //     if (isValidToPay) {
    //         onOpenBulk();
    //         return;
    //     }

    //     alert(`Please make sure you're selected same company or at least one checked`);
    // }

    // const handleConfirmToCancelBulk = () => {
    //     onCloseBulk();
    // }

    /*const handleConfirmToCancel = () => {
        setApprovalStatus('');
        onCloseView();
    }*/

    // const handleDrop = (acceptedFile: File[]) => {
    //     setUploadedFile(acceptedFile);
    // };

    // const [isLoadingBulk, setIsLoadingBulk] = useState(false);

    // const handleConfirmBulk = async () => {
    //     let listPromise = [] as any;
    //     if (!bulkPaymentDate) {
    //         return;
    //     }

    //     setIsLoadingBulk(true);
    //     dataRaw.data.forEach(async (element: any) => {
    //         const data = new FormData();
    //         data.append('invoiceId', element.id);
    //         data.append('paymentDate', bulkPaymentDate ?? '');
    //         data.append('paymentStatus', '1');
    //         data.append('modifiedBy', name || "System");
    //         data.append('file', uploadedFile ? uploadedFile[0] : '');
    //         // for (let [key, value] of data.entries()) {
    //         //     console.log(`${key}: ${value}`);
    //         // }
    //         listPromise.push(updatePaymentStatusInspectorOnlyAxios(data) as any);
    //     });

    //     const responses = await Promise.all(listPromise);
    //     const results = responses.map(response => response.status);
    //     const allStatusAre200 = results.every((item: any) => item === HttpStatusCode.Ok);
    //     setIsLoadingBulk(false);
    //     if (allStatusAre200) {
    //         toast({
    //             title: `${results.length} invoice status updated.`,
    //             description: `We've updated ${results.length} invoice status for you.`,
    //             status: 'success',
    //             duration: DURATION_TOAST,
    //             isClosable: true,
    //         });

    //         setTimeout(() => {
    //             onCloseBulk();
    //         }, 1000);
    //     } else {
    //         toast({
    //             title: `Invoice status failed to update`,
    //             description: `We failed to update invoice status for you.`,
    //             status: 'error',
    //             duration: DURATION_TOAST,
    //             isClosable: true,
    //         });
    //     }
    // }

    const handleChangeInvoiceStatus = (value: string) => {
        setInvoiceStatus(value);
    }

    const handleChangePaymentStatus = (value: string) => {
        setPaymentStatus(value);
    }

    const handleDownload = async (idFile: string) => {
			await downloadFile(idFile);
    }

    const handleDownloadZip = async (idFile: string, uploadType: number) => {
        await downloadFileZip(idFile, uploadType);
    }

    const setLatestCounterAdmin = async () => {
        const responseCounter = await getNewRecordCounterSuperAdmin() as any;
        if (responseCounter?.status === HttpStatusCode.Ok) {
            dispatch(setDataTotalNewInvoiceInspectingCompany(responseCounter?.data?.invoiceInspectingCompanyAdmin || 0));
        }
    }

    const setLatestCounterAdminFinance = async () => {
        const responseCounter = await getNewRecordCounterAdminFinance() as any;
        if (responseCounter?.status === HttpStatusCode.Ok) {
            dispatch(setDataTotalNewInvoiceInspectingCompany(responseCounter?.data?.inspectingCompany || 0));
            dispatch(setDataTotalNewInvoiceShipOperator(responseCounter?.data?.shipOperator || 0));
        }
    }

    const handleOpenConfirmPayment = async (id: string) => {
        setApprovalStatus('-1');
        setErrorMessageApproval('');
        setErrorMessageNote('');
        //setId(id);
        setIdConfirmationPayment(id);
        setApprovalNote('');
        setTotalAmountIDR(0);
        const data = dataList.find((x: any) => x.id === id);
        let newData = data as any;
        if (data) {
            newData = { ...data, invoiceID: data.invoiceNumber, totalReviews: data.totalReview, companyName: data.requestorName, downloadId: data.paymentFileId }
        }
        setDataConfirmation(newData);
        onOpenConfirmation();
    }

	const handleConfirmPayment = async (approvalStatus: string) => {
        if (approvalStatus === '-1'){
            setErrorMessageApproval('Please choose either approve or reject.');
            return;
        }
        
        if (approvalStatus === '3' && approvalNote.trim() === '') {
            setErrorMessageNote('Note is required');
            return;
        }

        if (approvalStatus === '4' && totalAmountIDR <= 0) {
            toast({
                title: 'Total amount in IDR is required',
                description: '',
                status: 'error',
                duration: DURATION_TOAST,
                isClosable: true,
            });
            return;
        }

        if (errorMessageNote) {
            return;
        }

			try {
					const data = new FormData();
					data.append('id', idConfirmationPayment);
					data.append('modifiedBy', name || "System");
					data.append('paymentStatus', approvalStatus);
					data.append('paymentDate', dataConfirmation.paymentDate);
					data.append('requestorId', dataConfirmation.requestorId);
					if (approvalStatus === String(PAYMENT_STATUS.REJECTED)) {
						data.append('approvalNote', approvalNote);
					} else {
						data.append('totalAmountIDR', String(totalAmountIDR)); // NO VALIDATION!
					}
					// for (let [key, value] of data.entries()) {
					//     console.log(`${key}: ${value}`);
					// }
					const response = await postUpdateSireReviewRequestorInvoicePayment(data);
					if (response.status === HttpStatusCode.Ok) {
						getData();
						toast({
							title: 'Payment confirmed.',
							description: "We've confirmed the payment.",
							status: 'success',
							duration: DURATION_TOAST,
							isClosable: true,
						});
					} else {
						throw new Error(response.message ?? "Something went wrong!")
					}
				} catch {
					toast({
						title: 'Invoice failed to update.',
						description: "We failed to confirm the payment.",
						status: 'error',
						duration: DURATION_TOAST,
						isClosable: true,
					});
				} finally {
					onCloseConfirmation();
					setApprovalNote("")
				}
    }

    const getData = async () => {
        const param = {
            search: searchValue,
            pageNumber: currentPageNumber === 0 ? 1 : currentPageNumber,
            pageSize: currentPageSize,
            status: '',
            invoiceStatus,
            paymentStatus
        };

        let response = {} as any;
            if (role === ROLES.SUPER_ADMIN) {
                response = await getListSireReviewRequestorInvoices(param);
                setLatestCounterAdmin();
            } else if (role === ROLES.FINANCE) {
                response = await getListSireReviewRequestorInvoicesFinance(param);
                setLatestCounterAdminFinance();
            } else if (role === ROLES.REQUESTOR) {
            const newParam = { ...param, requestorId: companyId };
            response = await getListSireReviewRequestorInvoicesByRequestor(newParam);
            //setLatestCounterInspectingCompany();
        }

        if (response.status === HttpStatusCode.Ok) {
            if (response.totalItem === 0){
                setDataList([]);
                setIsLoading(false);
                return;
            }
            setDataList(response.data);
            setTotalPageNumber(response.totalPage);
            setCurrentPageNumber(response.pageNumber);
            setHasNextPage(response.hasNextPage);
        } else {
            toast({
                title: response?.error?.code,
                description: response?.error?.message,
                status: 'error',
                duration: DURATION_TOAST,
                isClosable: true,
            });
        }

        setIsLoading(false);
    }

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        getData();
    }, [currentPageSize, currentPageNumber])

    return (
        <>
            {/*<ModalConfirmToPay isOpen={isOpenConfirmation} onClose={onCloseConfirmation} handleConfirmToCancel={handleConfirmToCancelConfirmation} handleConfirm={handleConfirmPayment} dataConfirmation={dataConfirmation} handleDownload={handleDownload} />*/}
            {/* <ModalBulkPaymentConfirmation isOpen={isOpenBulk} onClose={onCloseBulk} isLoadingBulk={isLoadingBulk} handleConfirmToCancel={handleConfirmToCancelBulk} handleConfirm={handleConfirmBulk} bulkPaymentDate={bulkPaymentDate} setBulkPaymentDate={setBulkPaymentDate} handleDrop={handleDrop} uploadedFile={uploadedFile} /> */}
            {/*<ModalInvoiceConfirmation isOpen={isOpenView} onClose={onCloseView} handleChangeNote={handleChangeNote} handleConfirmToCancel={handleConfirmToCancel} handleConfirm={handleConfirmView} approvalStatus={approvalStatus} handleChangeApprovalStatus={handleChangeApprovalStatus} selectedDataView={selectedDataView} errorMessageNote={errorMessageNote} />*/}
            <ModalSireRequestorPaymentConfirm
                isOpen={isOpenConfirmation}
                onClose={onCloseConfirmation}
                handleCancel={handleConfirmToCancelConfirmation}
                handleConfirm={handleConfirmPayment}
                approvalStatus={approvalStatus}
                handleChangeApprovalStatus={handleChangeApprovalStatus}
                errorMessageApproval={errorMessageApproval}
                errorMessageNote={errorMessageNote}
                handleChangeNote={handleChangeNote}
                handleDownload={handleDownload}
                dataConfirmation={dataConfirmation}
                amountIDR={totalAmountIDR}
                handleChangeAmountIDR={setTotalAmountIDR}
            />
            <ModalDelete title="Delete it?" isOpen={isOpen} onClose={onClose} handleConfirmDelete={handleConfirmDelete} />
            <div className="table-container">
                {role === ROLES.REQUESTOR &&
                    <div className="table-filter-action-container">
                        <div className="table-filter-container">
                            <div className="table-filter-input filter-input-width-8">
                                <Input placeholder='Search' onChange={(e: any) => handleChangeSearch(e.target.value)} />
                            </div>
                            <div className="table-filter-input filter-input-width-6">
                                <Select onChange={(e: any) => handleChangePaymentStatus(e.target.value)}>
                                    <option key="all" value=''>All Payment Status</option>
                                    <option key="unpaid" value={String(PAYMENT_STATUS.UNPAID)}>Unpaid</option>
                                    <option key="paid" value={String(PAYMENT_STATUS.PAID)}>In Progress</option>
                                    <option key="completed" value={String(PAYMENT_STATUS.COMPLETED)}>Paid</option>
                                </Select>
                            </div>
                            <div>
                                <Button className='table-search-button' bgColor={COLORS.BUTTON.BACKGROUND} color={COLORS.BUTTON.FOREGROUND} variant='solid' borderRadius={10} onClick={handleSubmitSearch}>
                                    Search
                                </Button>
                            </div>
                        </div>
                    </div>
                }
                {(role === ROLES.SUPER_ADMIN || role === ROLES.FINANCE) &&
                    <div className="table-filter-action-container">
                        <div className="table-filter-container">
                            <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', gap: '4px' }}>
                                <div style={{ display: 'flex', gap: '12px' }}>
                                    <div className="table-filter-input filter-input-width-8">
                                        <Input placeholder='Search' onChange={(e: any) => handleChangeSearch(e.target.value)} />
                                    </div>
                                    <div className="table-filter-input filter-input-width-6">
                                        <Select onChange={(e: any) => handleChangeInvoiceStatus(e.target.value)}>
                                            <option key="all" value=''>All Invoice Status</option>
                                            <option key="new" value={String(INVOICE_STATUS.IN_PROGRESS)}>New</option>
                                            <option key="finance" value={String(INVOICE_STATUS.FINANCE)}>Finance</option>
                                            <option key="approved" value={String(INVOICE_STATUS.APPROVED)}>Approved</option>
                                            <option key="reject" value={String(INVOICE_STATUS.REJECTED)}>Rejected</option>
                                        </Select>
                                    </div>
                                    <div className="table-filter-input filter-input-width-6">
                                        <Select onChange={(e: any) => handleChangePaymentStatus(e.target.value)}>
                                            <option key="all" value=''>All Payment Status</option>
                                            <option key="unpaid" value={String(PAYMENT_STATUS.UNPAID)}>Unpaid</option>
                                            <option key="paid" value={String(PAYMENT_STATUS.PAID)}>Paid</option>
                                            <option key="completed" value={String(PAYMENT_STATUS.COMPLETED)}>Completed</option>
                                        </Select>
                                    </div>
                                    <div>
                                        <Button className='table-search-button' bgColor={COLORS.BUTTON.BACKGROUND} color={COLORS.BUTTON.FOREGROUND} variant='solid' borderRadius={10} onClick={handleSubmitSearch}>
                                            Search
                                        </Button>
                                    </div>
                 
                                <div className="table-filter-separator"/>
                                {(role === ROLES.SUPER_ADMIN) &&
                                    <Button leftIcon={<AddIcon />} className='table-add-button' bgColor={COLORS.BUTTON.BACKGROUND} color={COLORS.BUTTON.FOREGROUND} variant='solid' borderRadius={10} onClick={handleNavAdd}>
                                        Create Invoice
                                    </Button>
                                }
                                </div>
                            </div>    
                        </div>
                    </div>
                }
                <TableInvoiceSireReviewRequestor
                    dataList={dataList}
                    isLoading={isLoading}
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                    currentPageSize={currentPageSize}
                    handleChangePageSize={setCurrentPageSize}
                    handleChangePageNumber={setCurrentPageNumber}
                    currentPageNumber={currentPageNumber}
                    totalPageNumber={totalPageNumber}
                    hasNextPage={hasNextPage}
                    //handleView={handleView}
                    handlePay={handlePay}
                    //handleDownload={handleDownload}
                    handleDownloadZip={handleDownloadZip}
                    handleConfirmPayment={handleOpenConfirmPayment}
                    role={role}
                />
            </div>
        </>
    )
}

export default InvoicesSireReviewRequestorList;
